import React from "react";
import { ImFacebook2 } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import facbookIcon from "../image/icons8-facebook.svg";
const Login = ({
  password,
  setPassword,
  handleLogin,
  handleLoginWithGoogle,
  error,
  signup,
  confirmPassword,
  setConfirmPassword,
  setEmail,
  email,
  name,
  setName,
  facebookSignup,
}) => {
  const navigate = useNavigate();

  const handleReset = () => {
    setEmail("");
    setPassword("");
  };

  return (
    <div class="min-h-screen">
      <div class="max-w-lg mx-auto my-10 bg-white p-8 rounded-xl shadow shadow-slate-300 max-h-100">
        <h1
          class="text-4xl"
          style={{
            color: "var(--primary-color)",
            padding: "10px",
            textAlign: "center",
          }}
        >
          {signup ? "انشاء حساب جديد" : "تسجيل الدخول"}
        </h1>
        {!signup && (
          <p
            class="text-slate-500"
            style={{
              color: "var(--primary-color)",
              padding: "10px",
              textAlign: "center",
            }}
          >
            مرحبا بك مرة اخرى 👋
          </p>
        )}

        <div class="my-5">
          <button
            class="w-full text-center py-3 my-3 border flex space-x-2 items-center justify-center  rounded-lg text-slate-700 hover:border-slate-400 hover:text-slate-900 hover:shadow transition duration-150"
            style={{ border: "1px solid #333" }}
            onClick={handleLoginWithGoogle}
          >
            <img
              src="https://www.svgrepo.com/show/355037/google.svg"
              class="w-6 h-6"
              alt=""
            />{" "}
            <span
              style={{
                color: "#333",
                fontWeight: "bold",
                fontSize: "18px",
                padding: "0 10px",
              }}
            >
              {signup ? " انشاء حساب  باستخدام جوجل" : "تسجيل الدخول بجوجل"}
            </span>
          </button>
        </div>

        <div class="my-5">
          <button
            class="w-full text-center py-3 my-3 border flex space-x-2 items-center justify-center  rounded-lg text-slate-700 hover:border-slate-400 hover:text-slate-900 hover:shadow transition duration-150"
            style={{ border: "1px solid #333" }}
            onClick={facebookSignup}
          >
            <img src={facbookIcon} class="w-8 h-8" alt="" />{" "}
            <span
              style={{
                color: "#333",
                fontWeight: "bold",
                fontSize: "18px",
                padding: "0 10px",
              }}
            >
              {signup ? " انشاء حساب  باستخدام فيسبوك" : "تسجيل الدخول بفيسبوك"}
            </span>
          </button>
        </div>

        <form action="" class="my-10">
          <div class="flex flex-col space-y-5">
            {signup && (
              <label for="name">
                <p class="font-medium text-slate-700 pb-2">الاسم</p>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  class="w-full py-3 border rounded-lg px-3 focus:outline-none focus:border-slate-500 hover:shadow"
                  style={{ border: "1px solid #333", color: "#333" }}
                  placeholder="ادخل اسمك"
                />
              </label>
            )}
            <label for="email">
              <p class="font-medium text-slate-700 pb-2">
                عنوان البريد الالكتروني
              </p>
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                class="w-full py-3 border rounded-lg px-3 focus:outline-none focus:border-slate-500 hover:shadow"
                style={{ border: "1px solid #333", color: "#333" }}
                placeholder="ادخل عنوان البريد الالكتروني"
              />
            </label>
            <label for="password">
              <p class="font-medium text-slate-700 pb-2">كلمة المرور</p>
              <input
                id="password"
                name="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                class="w-full py-3 border rounded-lg px-3 focus:outline-none focus:border-slate-500 hover:shadow"
                style={{ border: "1px solid #333", color: "#333" }}
                placeholder="ادخل كلمة المرور"
              />
            </label>
            {signup && (
              <label for="password">
                <p class="font-medium text-slate-700 pb-2">كلمة المرور</p>
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  class="w-full py-3 border rounded-lg px-3 focus:outline-none focus:border-slate-500 hover:shadow"
                  style={{ border: "1px solid #333", color: "#333" }}
                  placeholder="ادخل كلمة المرور"
                />
              </label>
            )}
            {error && (
              <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>
            )}{" "}
            <button
              class="w-full py-3 font-medium text-white bg-indigo-600 hover:bg-indigo-500 rounded-lg border-indigo-500 hover:shadow inline-flex space-x-2 items-center justify-center"
              onClick={handleLogin}
            >
              <span>تسجيل الدخول</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 mx-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                />
              </svg>
            </button>
            <p
              class="text-center"
              style={{
                color: "var(--primary-color)",
                padding: "10px",
                textAlign: "center",
              }}
            >
              {signup ? "لديك حساب بالفعل؟" : "ليس لديك حساب؟"}{" "}
              <p
                class="font-medium inline-flex space-x-1 items-center"
                style={{ color: "var(--primary-color)" }}
              >
                <span
                  style={{
                    color: "var(--primary-color)",
                    padding: "0 10px",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate(
                      signup ? "/login" : "/signup",
                      signup ? { replace: true } : { replace: false }
                    );
                  }}
                >
                  {signup ? "تسجيل الدخول" : "انشاء حساب جديد"}
                </span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </span>
              </p>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
